<template>
  <div class="container">
    <div class="large-12 medium-12 small-12 filezone">
      <input type="file" id="files" ref="files" v-on:change="handleFiles()" />
      <p>
        Arraste seus arquivos aqui
        <br>ou clique para buscar
        <br>(Formatos aceitos: .ai, .psd, .jpg, .png, .zip, .rar, .pdf)
        <br>Tamanho máximo por arquivo: 50MB
      </p>
    </div>

    <div v-for="(file, key) in files" v-bind:key="key" class="file-listing">
      <img class="preview" v-bind:ref="'preview'+parseInt(key)" />
      {{ file.name }}
      <div class="success-container" v-if="file.id > 0">Success</div>
      <div class="remove-container" v-else>
        <a class="remove" v-on:click="removeFile(key)">Remove</a>
      </div>
    </div>

    <vs-button class="submit-button" v-on:click="submitFiles()" v-show="files.length > 0">Enviar</vs-button>
  </div>
</template>

<script>
import questSubmissionFileService from "../../_services/questSubmissionFile.service.js";

export default {
  props: ["input_name", "post_url", "quest_submission_id"],
  data() {
    return {
      files: []
    };
  },
  methods: {
    handleFiles() {
      let uploadedFiles = this.$refs.files.files;

      for (var i = 0; i < uploadedFiles.length; i++) {
        let allowedFileExtensions = [
          "ai",
          "psd",
          "jpg",
          "jpeg",
          "png",
          "zip",
          "rar",
          "pdf"
        ];
        let fileExt = uploadedFiles[i].name.split(".").pop();
        if (!allowedFileExtensions.includes(fileExt)) {
          this.$vs.notify({
            color: "danger",
            title: "Erro",
            text: "Formato de arquivo não suportado!"
          });
          return;
        }
        if (uploadedFiles[i].size > (1024 * 1024 * 50)) {
          this.$vs.notify({
            color: "danger",
            title: "Erro",
            text: "Tamanho máximo de arquivo excedido!"
          });
          return;
        }
        this.files.push(uploadedFiles[i]);
      }
      this.getImagePreviews();
    },
    getImagePreviews() {
      for (let i = 0; i < this.files.length; i++) {
        if (/\.(jpe?g|png|gif)$/i.test(this.files[i].name)) {
          let reader = new FileReader();
          reader.addEventListener(
            "load",
            function() {
              this.$refs["preview" + parseInt(i)][0].src = reader.result;
            }.bind(this),
            false
          );
          reader.readAsDataURL(this.files[i]);
        } else {
          this.$nextTick(function() {
            this.$refs["preview" + parseInt(i)][0].src = "/img/generic.png";
          });
        }
      }
    },
    removeFile(key) {
      this.files.splice(key, 1);
      this.getImagePreviews();
    },
    async submitFiles() {
      if (this.files.length > 3) {
        this.$vs.notify({
          color: "danger",
          title: "Erro no upload",
          text: "Você pode enviar no máximo 3 arquivos"
        });
        return;
      }
      for (let i = 0; i < this.files.length; i++) {
        if (this.files[i].id) {
          continue;
        }
        let formData = new FormData();
        formData.append("file", this.files[i]);
        formData.append("quest_submission_id", this.quest_submission_id);

        try {
            this.$vs.loading();
          let data = await questSubmissionFileService.create(formData);
          this.$vs.loading.close();
          if (data) {
            this.files[i].id = data["data"]["id"];
            this.files.splice(i, 1, this.files[i]);
            location.reload();
          }
        } catch (error) {
          this.$vs.notify({
            color: "danger",
            title: "Erro no upload",
            text: error
          });
        }
      }
    }
  }
};
</script>
<style scoped>
input[type="file"] {
  opacity: 0;
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}
.filezone {
  outline: 2px dashed grey;
  outline-offset: -10px;
  background: #ccc;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px;
  position: relative;
  cursor: pointer;
}
.filezone:hover {
  background: #c0c0c0;
}

.filezone p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 50px 50px 50px;
}
div.file-listing img {
  max-width: 90%;
}

div.file-listing {
  margin: auto;
  padding: 10px;
  border-bottom: 1px solid #ddd;
}

div.file-listing img {
  height: 100px;
}
div.success-container {
  text-align: center;
  color: green;
}

div.remove-container {
  text-align: center;
}

div.remove-container a {
  color: red;
  cursor: pointer;
}

a.submit-button {
  display: block;
  margin: auto;
  text-align: center;
  width: 200px;
  padding: 10px;
  text-transform: uppercase;
  background-color: #ccc;
  color: white;
  font-weight: bold;
  margin-top: 20px;
}
</style>